// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.ds.DataSourceRecord
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { DataSourceRecord } from "abweb/dto/ds/DataSourceRecord";
import { DataSourceValue } from "abweb/dto/ds/DataSourceValue";
import { DataSourceSaveAction } from "abweb/dto/generated/ds/DataSourceSaveAction";
import { DataSourceState } from "abweb/dto/generated/ds/DataSourceState";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class DataSourceRecordBase extends DataSourceValue {
  /** Do NOT invoke directly, instead use strongly typed createDataSourceRecordBase factory method */
  constructor() {
    super();
  }

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadd.DataSourceRecord";
  }
  initFromJson(json, deserializeContext) {
    this.initDataSourceRecord(json.attributeValues != null ? json.attributeValues : null, json.clientTag != null ? json.clientTag : null, json.dataSourceSaveAction != null ? DataSourceSaveAction.fromJson(json.dataSourceSaveAction) : null, json.editableOverwrite != null ? json.editableOverwrite : null, json.id != null ? json.id : null, json.state != null ? DataSourceState.fromJson(json.state) : null, json.childRecords != null ? TSOGUtils.decodeObjectArray(json.childRecords, DataSourceRecord, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "childRecords")) : null, json.deletable != null ? json.deletable : null, json.updateStamp != null ? json.updateStamp : null, json.values != null ? TSOGUtils.decodeObjectMap(json.values, null, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "values")) : null);
  }
  initDataSourceRecord(attributeValues, clientTag, dataSourceSaveAction, editableOverwrite, id, state, childRecords, deletable, updateStamp, values) {
    this.initDataSourceValue(attributeValues, clientTag, dataSourceSaveAction, editableOverwrite, id, state);
    this._childRecords = childRecords;
    this._deletable = deletable;
    this._updateStamp = updateStamp;
    this._values = values;
  }
  toTSOG(result, serializeContext) {
    const retVal = super.toTSOG(result, serializeContext);
    if (this._childRecords != null) {
      retVal["childRecords"] = TSOGUtils.toTSOGArray(this._childRecords, serializeContext);
    }
    retVal["deletable"] = this._deletable;
    if (this._updateStamp != null) {
      retVal["updateStamp"] = this._updateStamp;
    }
    retVal["values"] = TSOGUtils.toTSOGMap(this._values, serializeContext);
    return retVal;
  }
  get childRecords() {
    return this._childRecords;
  }
  set childRecords(value) {
    this._childRecords = value;
  }
  get deletable() {
    return this._deletable;
  }
  set deletable(value) {
    this._deletable = value;
  }
  get updateStamp() {
    return this._updateStamp;
  }
  set updateStamp(value) {
    this._updateStamp = value;
  }
  get values() {
    return this._values;
  }
  set values(value) {
    this._values = value;
  }
}
//# sourceMappingURL=DataSourceRecordBase.js.map
